<template>
    <div ref="treemap" class="container"></div>
</template>

<script>
import echarts from 'echarts';
import {chartMerge} from 'echarts-config';
import {treemapData} from '@/runtime-components/data';
export default {
    name: 'de-treemap',
    props: {
        data: {
            type: Object,
            default: () => {
                return treemapData;
            }
        },  
        // color1: {
        //     type: String
        // },
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    watch: {
        // color1() {
        //     let chart = this.getChart().chart;
        //     chart && (chart.setOption({
        //         color1: this.color1
        //     }));
        // },
        data: {
            handler(v) {
                let chart = this.getChart().chart;
                chart && (chart.setOption({
                    series: [{
                        data: this.data.data
                    }],
                }));
            },
            deep: true
        }
    },
    methods: {
        initChart(type) {
            let chartIns = this.getChart();
            //初始化设置主题 dark light
            window._CHART_THEMETYPE_ = type || 'dark';
            //echarts1
            const chart = chartMerge(
                {
                    chartType: 'lineBar'
                },{
                        series: [{
                            type: 'treemap',
                            data: [{
                                name: 'nodeA',            // First tree
                                value: 10,
                                // 颜色
                                // itemStyle: {
                                //     normal: {
                                //         color: this.color1,
                                //     }
                                // },
                                children: [{
                                    name: 'nodeAa',       // First leaf of first tree
                                    value: 4
                                }, {
                                    name: 'nodeAb',       // Second leaf of first tree
                                    value: 6
                                }]
                            }, {
                                name: 'nodeB',            // Second tree
                                value: 20,
                                children: [{
                                    name: 'nodeBa',       // Son of first tree
                                    value: 20,
                                    children: [{
                                        name: 'nodeBa1',  // Granson of first tree
                                        value: 20
                                    }]
                                }]
                            }]
                        }]
                    });
                    
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs['treemap']);
                chartIns.chart.setOption(chart);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style scoped>
@import url('~@/runtime-components/assets/common.css');
</style>